import axios from 'axios';
import getApiBaseUrl from '../GetServer';

export const UpdNameRole = async (IDRol: number, NewName: string) => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/update-name-role`;

    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error('Token no disponible');
    }

const response = await axios.post(
      endpoint,
      { 
        IDRol,
        NewName 
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (response.data.status !== 200) {
      throw new Error(response.data.message);
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
};